export const FORUM_NOT_INSTALLED_ERROR = new Error('Forum not installed');
